import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const MixItRight = () => {
  const [target, setTarget] = useState({ orange: 3, pink: 2 });
  const [orangeInput, setOrangeInput] = useState(0);
  const [pinkInput, setPinkInput] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackClass, setFeedbackClass] = useState('');

  const successSound = useRef(null);
  const failSound = useRef(null);

  useEffect(() => {
    updateTargetRatioDisplay();
  }, []);

  const updateTargetRatioDisplay = () => {
    setFeedback('');
    setFeedbackClass('');
  };

  const generateNewRatio = () => {
    const a = Math.floor(Math.random() * 4) + 1;
    const b = Math.floor(Math.random() * 4) + 1;
    setTarget({ orange: a, pink: b });
    setOrangeInput(0);
    setPinkInput(0);
    updateTargetRatioDisplay();
  };

  const checkMix = () => {
    const orange = parseInt(orangeInput);
    const pink = parseInt(pinkInput);

    const ratioCorrect = orange * target.pink === pink * target.orange;
    const total = orange + pink;

    const orangePercent = total > 0 ? (orange / total) * 100 : 0;
    const pinkPercent = total > 0 ? (pink / total) * 100 : 0;

    document.getElementById("orangeLiquid").style.height = `${orangePercent}%`;
    document.getElementById("pinkLiquid").style.height = `${pinkPercent}%`;

    if (ratioCorrect && total > 0) {
      setFeedback("✅ Correct Ratio! Well Done!");
      setFeedbackClass("correct");
      successSound.current.play();
          const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFeedback("❌ Try Again. Ratio doesn't match.");
      setFeedbackClass("wrong");
      failSound.current.play();
    }
  };

  return (
    <div style={{ fontFamily: 'Fredoka One', background: 'linear-gradient(to bottom right, #74ebd5, #acb6e5)', color: '#fff', textAlign: 'center', minHeight: '100vh', padding: '40px 0' }}>
      <div>
        {/* <img src="https://i.imgur.com/IkqQe3U.png" alt="Scientist" style={{ width: 120, animation: 'bounce 3s infinite', marginBottom: 20 }} /> */}
        <h1 style={{ fontSize: '3rem', textShadow: '2px 2px #4a4a4a' }}>Mix It Right!</h1>
        <h2 style={{ fontSize: '1.8rem', color: '#fffae5' }}>Target Ratio: {target.orange}:{target.pink}</h2>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 40, marginBottom: 20 }}>
          <div style={{ width: 120, height: 200, border: '5px solid white', borderRadius: '20px 20px 0 0', position: 'relative', background: '#ffffff22', overflow: 'hidden' }}>
            <div id="orangeLiquid" style={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'orange', height: '0%', transition: 'height 0.5s ease' }}></div>
          </div>
          <div style={{ width: 120, height: 200, border: '5px solid white', borderRadius: '20px 20px 0 0', position: 'relative', background: '#ffffff22', overflow: 'hidden' }}>
            <div id="pinkLiquid" style={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'deeppink', height: '0%', transition: 'height 0.5s ease' }}></div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 40, marginBottom: 20 }}>
          <label style={{ fontSize: 20 }}>
            <input type="number" min="0" max="10" value={orangeInput} onChange={e => setOrangeInput(e.target.value)} style={{ width: 60, fontSize: 20, textAlign: 'center', borderRadius: 10, border: '2px solid #fff', padding: 5,color:"brown", marginLeft: 10 }} />
          </label>
          <label style={{ fontSize: 20 }}>
            <input type="number"  value={pinkInput} onChange={e => setPinkInput(e.target.value)} style={{ width: 60, fontSize: 20, textAlign: 'center', borderRadius: 10, border: '2px solid #fff', padding: 5,color:"brown", marginLeft: 10 }} />
          </label>
        </div>

        <div>
          <button onClick={checkMix} style={{ padding: '10px 25px', fontSize: 18, margin: 10, border: 'none', borderRadius: 20, cursor: 'pointer', backgroundColor: '#00cc99', color: 'white' }}>Mix</button>
          <button onClick={generateNewRatio} style={{ padding: '10px 25px', fontSize: 18, margin: 10, border: 'none', borderRadius: 20, cursor: 'pointer', backgroundColor: '#ff9933', color: 'white' }}>Next</button>
        </div>

        <div style={{ fontSize: 28, marginTop: 20, height: 40 }} className={feedbackClass}>{feedback}</div>
      </div>

      <audio ref={successSound} src="https://cdn.pixabay.com/download/audio/2022/02/10/audio_47b3ba5f9d.mp3?filename=correct-6033.mp3" preload="auto"></audio>
      <audio ref={failSound} src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_8636c7bc2f.mp3?filename=error-2-126514.mp3" preload="auto"></audio>
    </div>
  );
};

export default MixItRight;
